import { VESSELSELECTED } from "../../actions/portal";

export default function(state = [], action) {
  switch (action.type) {
    case VESSELSELECTED:
      return [action.payload, ...state];
    default:
  }

  return state;
}
